import { clsx } from 'clsx';
import * as React from 'react';
import { getDeviceStyles } from '../../styles/tab/getDeviceStyles';
import { useDeviceType } from '../../../../responsive/hooks/useDeviceType';
import { jsx as _jsx } from "react/jsx-runtime";
export const Tab = _ref => {
  let {
    title,
    disabled,
    active,
    focusVisible,
    onClick
  } = _ref;
  const deviceType = useDeviceType();
  const styles = getDeviceStyles(deviceType);
  return /*#__PURE__*/_jsx("button", {
    disabled: disabled,
    type: "button",
    role: "tab",
    "aria-selected": active,
    tabIndex: active ? 0 : -1,
    className: clsx(styles['tab'], active && styles['active'], focusVisible && styles['focus-visible']),
    onClick: onClick,
    children: /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      children: title
    })
  });
};